// @flow
import { Formik } from 'formik';
import React from 'react';
import { object, string } from 'yup';
import { useHistory, useParams } from 'react-router-dom';

import { useAddNativeInferencePoolMutation } from '../../../service-definitions/estimates';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';
import { StyledContainer } from '../../../common-utils/styledComponents';
import { ConfirmModal } from '../../presentational/modals/ConfirmModal';
import { Form } from '../../../formik-utils/formikSUIWrapper';
import { TextField } from '../../../formik-utils/FormFields';
import { toastError } from '../../presentational/notifications/utils';
import { getLinkForNativeInferencePool } from '../../links/utils';
import {
  NATIVE_INFERENCE_POOL_NAME,
  NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME,
} from '../../../constants';

export const NativeInferencePoolAddModal = ({ isOpen, setOpen }) => {
  const { estimateId } = useParams();
  const [addNativeInferencePool] = useAddNativeInferencePoolMutation();
  const estimateVersion = useEstimateVersion();
  const { push } = useHistory();

  const initialValues = {
    [NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME]: '',
  };

  const validationSchema = object({
    [NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME]: string().required('Pool Name is required'),
  });

  return (
    <StyledContainer>
      <Formik
        autoComplete="off"
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={() => {}}
        validateOnMount={true}
        validationSchema={validationSchema}
      >
        {(addNativeInferencePoolFormik) => (
          <ConfirmModal
            body={
              <StyledContainer>
                <Form autoComplete="off">
                  <TextField
                    disableOnFormErrors={false}
                    fieldDisplayName={NATIVE_INFERENCE_POOL_NAME}
                    fieldName={NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME}
                  />
                </Form>
              </StyledContainer>
            }
            cancelButtonNegative={true}
            disabled={!addNativeInferencePoolFormik.isValid}
            header="Add New Inference Pool"
            isOpen={isOpen}
            okButtonNegative={false}
            okButtonText="Continue"
            onClickHandlerForCancel={() => setOpen(false)}
            onClickHandlerForOK={async () => {
              const { error, data } = await addNativeInferencePool({
                estimateId,
                payload: {
                  estimate_id: estimateId,
                  name: addNativeInferencePoolFormik.values[
                    NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME
                  ],
                  estimate_version: estimateVersion,
                },
              });

              if (error) {
                toastError(error);
              } else {
                push(getLinkForNativeInferencePool(estimateId, data.id));
              }
              setOpen(false);
            }}
          />
        )}
      </Formik>
    </StyledContainer>
  );
};
